'use client';

import styles from './resultListModal.module.scss';
import Button from '@next-app/components/elements/Button/Button';
import Heading from '@next-app/components/elements/Heading/Heading';
import GenericImage from '@next-app/components/elements/GenericImage/GenericImage';
import { IResultModalPDPProps } from '@next-app/interface/PDP/PDPAddToList';
import Conditional from '@next-app/components/Conditional';
import ProductPrice from '../ProductPrice/ProductPrice';
import parse from 'html-react-parser';
import { ShowModalProps } from '@next-app/interface/Common';
import DynamicModal from '@next-app/components/elements/DynamicModal/DynamicModal';

const ResultListModal = (props: IResultModalPDPProps & ShowModalProps) => {
  const {
    productId,
    listName,
    productName,
    productQty,
    setShowModal,
    selectedProductImage,
    modalTitle,
    modalUrl,
    modalBtnTxt,
    selectedSku,
    showModal,
  } = props;
  const priceInfo = selectedSku?.priceInfo;

  const modalMsg = modalBtnTxt === 'View Registry' ? 'Registry' : 'List';
  return (
    <Conditional if={showModal}>
      <DynamicModal
        modalContentClass={`ll-medium ${styles['modal-dialog-wrp']}`}
        centerClass={`added-registry-modal ${styles['modal-dialog-centered']}`}
        modalTitle={modalTitle}
        onModalClose={() => setShowModal(false)}
      >
        <Heading
          tagName={'4'}
          customClass={`ll-fs-22 d-flex align-items-center mb-ll-3 ll-black-primary ${styles['item-heading']}`}
        >
          <i className={`ls-icon ${styles['icn-check-sld-circle']}`}></i>
          {`${productQty} item added to ${listName}'s ${modalMsg}`}
        </Heading>
        <div
          className={`d-flex align-items-start ${styles['product-container']} row g-3`}
        >
          <div className="col-4">
            <Conditional if={!!selectedProductImage}>
              <GenericImage
                src={selectedProductImage}
                alt={productName}
                loading={'eager'}
                width={160}
                height={120}
              />
            </Conditional>
          </div>
          <div
            className={`d-flex flex-column p-0 justify-content-center ${styles['product-details']} col-6`}
          >
            <div className={`fw-bold ${styles['product-name']}`}>
              {parse(productName)}
            </div>
            <div className={styles['product-price']}>
              <ProductPrice productId={productId} priceRange={priceInfo} />
            </div>
            <div
              className={`p-0 ${styles['product-qty']}`}
            >{`Qty: ${productQty}`}</div>
          </div>
        </div>

        <div
          className={`d-flex justify-content-md-end flex-md-row flex-column pe-md-2 p-0 ${styles['modal-dialog-button-wrap']}`}
        >
          <Button
            variant="ternary"
            data-bs-dismiss="modal"
            customClass={`${styles['action-btn']} order-2 order-md-0`}
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
          <Button
            data-testid="modal-button"
            variant="primary"
            data-bs-dismiss="modal"
            customClass={`${styles['action-btn']} order-1 order-md-2 ms-0 ms-md-3 mb-3 mb-md-0`}
            link={modalUrl}
            onClick={() => setShowModal(false)}
          >
            {modalBtnTxt}
          </Button>
        </div>
      </DynamicModal>
    </Conditional>
  );
};

export default ResultListModal;
